import { defineComponent as B, computed as u, openBlock as c, createBlock as y, unref as d, normalizeClass as f, createSlots as g, withCtx as s, renderSlot as n, normalizeProps as i, guardReactiveProps as r, createElementVNode as m, createElementBlock as p, createVNode as b, createCommentVNode as $ } from "vue";
import { RevButtonIcon as h } from "@ds/components/ButtonIcon";
import { RevModalBase as w } from "@ds/components/ModalBase";
import { RevStickyBar as T } from "@ds/components/StickyBar";
import N from "../../icons/generated/IconArrowLeft.vue2.js";
import { tw as l } from "../../utils/tailwind.js";
const z = { class: "flex h-full flex-col" }, A = {
  key: 0,
  class: "w-full self-end"
}, V = /* @__PURE__ */ B({
  name: "RevDrawer",
  __name: "Drawer",
  props: {
    hasBackButton: { type: Boolean, default: !1 },
    backButtonLabel: { default: "" },
    name: {},
    title: { default: "" },
    closeButtonLabel: { default: () => {
    } },
    hasPadding: { type: Boolean, default: !0 },
    size: { default: "small" },
    to: { default: "body" },
    defer: { type: Boolean, default: !1 },
    backdropZIndex: { default: () => {
    } },
    backgroundColor: { default: "mid" },
    beforeTitleClassNames: { type: [String, Boolean, Array, Object], default: "" },
    afterTitleClassNames: { type: [String, Boolean, Array, Object], default: "" },
    disableCloseOnBackdropClick: { type: Boolean, default: !1 },
    shouldKeepAlive: { type: Boolean, default: !1 }
  },
  emits: ["open", "close", "back"],
  setup(e) {
    const k = u(() => {
      const t = {
        small: l`md:w-380`,
        medium: l`md:w-640`,
        large: l`md:w-[61rem] md:max-w-full`
      };
      return [
        l`h-full md:rounded-l-lg md:left-auto md:right-0 md:top-0`,
        t[e.size]
      ];
    }), v = {
      enterActiveClass: l`motion-safe:transition-transform motion-safe:duration-300`,
      enterFromClass: l`translate-y-full md:translate-x-full md:translate-y-0`,
      leaveActiveClass: l`motion-safe:transition-transform motion-safe:duration-200`,
      leaveToClass: l`translate-y-full md:translate-x-full md:translate-y-0`
    }, C = u(
      () => e.hasPadding && [l`p-24`, !e.title && l`pt-0`]
    );
    return (t, o) => (c(), y(d(w), {
      "backdrop-z-index": e.backdropZIndex,
      "background-color": e.backgroundColor,
      class: f(k.value),
      "close-button-label": e.closeButtonLabel,
      defer: e.defer,
      "disable-close-on-backdrop-click": e.disableCloseOnBackdropClick,
      "has-body-overflow": !1,
      "has-padding": !1,
      name: e.name,
      "should-keep-alive": e.shouldKeepAlive,
      title: e.title,
      to: e.to,
      "transition-class-names": v,
      onClose: o[1] || (o[1] = (a) => t.$emit("close", a)),
      onOpen: o[2] || (o[2] = (a) => t.$emit("open"))
    }, g({
      body: s(({ close: a }) => [
        m("div", z, [
          m("div", {
            class: f(["flex-auto overflow-auto", C.value])
          }, [
            n(t.$slots, "body", i(r({ close: a })))
          ], 2),
          t.$slots.footer ? (c(), p("div", A, [
            b(d(T), {
              class: "pb-12",
              position: "bottom",
              "snap-to-view-port": !1
            }, {
              default: s(() => [
                n(t.$slots, "footer", i(r({ close: a })))
              ]),
              _: 2
            }, 1024)
          ])) : $("", !0)
        ])
      ]),
      trigger: s(({ open: a }) => [
        n(t.$slots, "trigger", i(r({ open: a })))
      ]),
      _: 2
    }, [
      e.hasBackButton || t.$slots.beforeTitle ? {
        name: "beforeTitle",
        fn: s(({ close: a }) => [
          m("div", {
            class: f(["absolute left-0", e.beforeTitleClassNames])
          }, [
            n(t.$slots, "beforeTitle", i(r({ close: a })), () => [
              b(d(h), {
                "alternative-text": e.backButtonLabel,
                icon: d(N),
                variant: "ghost",
                onClick: o[0] || (o[0] = (O) => t.$emit("back"))
              }, null, 8, ["alternative-text", "icon"])
            ])
          ], 2)
        ]),
        key: "0"
      } : void 0,
      t.$slots.afterTitle ? {
        name: "afterTitle",
        fn: s(({ close: a }) => [
          m("div", {
            class: f(["absolute right-0 top-0", e.afterTitleClassNames])
          }, [
            n(t.$slots, "afterTitle", i(r({ close: a })))
          ], 2)
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["backdrop-z-index", "background-color", "class", "close-button-label", "defer", "disable-close-on-backdrop-click", "name", "should-keep-alive", "title", "to"]));
  }
});
export {
  V as default
};
